"use client";

import React from "react";

export function Faq13() {
  return (
    <section id="relume" className="bg-wood-green text-white font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto">
        <div className="rb-12 mb-12 w-full max-w-2xl md:mb-18 lg:mb-20">
          <h2 className="mb-5 text-[36px] font-bold font-serif leading-[1.2] md:text-[56px]">
            Často kladené dotazy
          </h2>
          <p className="text-base md:text-lg opacity-90">
            Odpovědi na to, co vás zajímá o našem řemesle
          </p>
        </div>
        
        <div className="grid grid-cols-1 gap-10 gap-y-10 md:grid-cols-3 md:gap-x-8 md:gap-y-16 lg:gap-x-12">
          
          <div>
            <h3 className="mb-3 text-[18px] font-bold font-sans leading-[1.4]">
              Jak dlouho trvá stavba?
            </h3>
            <p className="text-[16px] font-sans opacity-90">
              Záleží na projektu. Malá obnova trvá měsíce, nový dům rok či dva.
              Nespěcháme. Děláme to správně.
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-[18px] font-bold font-sans leading-[1.4]">
              Pracujete v chráněných krajinách?
            </h3>
            <p className="text-[16px] font-sans opacity-90">
              Ano. Máme zkušenost s úřady na ochranu přírody a památek. Víme,
              jaké jsou požadavky, a respektujeme je.
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-[18px] font-bold font-sans leading-[1.4]">
              Jaké dřevo používáte?
            </h3>
            <p className="text-[16px] font-sans opacity-90">
              Vybíráme podle projektu a místa. Často jde o smrk nebo jedle.
              Důležité je kvalita a původ materiálu.
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-[18px] font-bold font-sans leading-[1.4]">
              Můžete obnovit starý dům?
            </h3>
            <p className="text-[16px] font-sans opacity-90">
              Je to naše specialita. Starý dům má svou logiku. Učíme se ji číst
              a respektovat ji při obnově.
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-[18px] font-bold font-sans leading-[1.4]">
              Jaká je vaše záruka?
            </h3>
            <p className="text-[16px] font-sans opacity-90">
              Stavíme tak, aby to vydrželo. Záruka je v tom, jak pracujeme, a v
              tom, že se za svou prací postavíme.
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-[18px] font-bold font-sans leading-[1.4]">
              Potřebujete poradit?
            </h3>
            <p className="text-[16px] font-sans opacity-90">
              Čas není nepřítel, je součást procesu. Nespěcháme, protože spěch kazí dřevo i řemeslo. Rádi s vámi probereme váš záměr.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}